export default "__VITE_ASSET__DbZvT$7G__"